/* Translate only a native consent UI's verified English fallback.
 * Native nodes, event handlers, checkboxes and consent storage remain intact.
 * Non-English native/custom copy is deliberately left alone.
 */
(() => {
  const data = document.getElementById('bayrak-consent-locale');
  if (!data || !/^(de|fr|it|ar)(-|$)/i.test(document.documentElement.lang)) return;
  let config;
  try { config = JSON.parse(data.textContent); } catch { return; }
  const normalize = value => String(value).replace(/\s+/g, ' ').trim();
  const translations = new Map(config.entries.map(entry => [normalize(entry.source), entry.value]));
  const selector = '#shopify-pc__banner, #shopify-pc__prefs';
  const translate = root => {
    const walk = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    for (let node = walk.nextNode(); node; node = walk.nextNode()) {
      if (/^(SCRIPT|STYLE)$/.test(node.parentElement?.tagName)) continue;
      const value = translations.get(normalize(node.nodeValue));
      if (value && normalize(node.nodeValue) !== normalize(value)) {
        node.nodeValue = (node.nodeValue.match(/^\s*/)?.[0] || '') + value +
          (node.nodeValue.match(/\s*$/)?.[0] || '');
      }
    }
    root.querySelectorAll('[aria-label]').forEach(node => {
      const value = translations.get(normalize(node.getAttribute('aria-label')));
      if (value && value !== node.getAttribute('aria-label')) node.setAttribute('aria-label', value);
    });
    const policy = root.querySelector('#shopify-pc__banner__body-policy-link');
    if (policy?.href === config.policySource) {
      policy.href = config.root.replace(/\/$/, '') + '/policies/privacy-policy';
    }
  };
  let scheduled = false;
  const update = () => {
    scheduled = false;
    document.querySelectorAll(selector).forEach(translate);
  };
  const schedule = () => {
    if (!scheduled) { scheduled = true; queueMicrotask(update); }
  };
  const observer = new MutationObserver(records => {
    if (records.some(record => {
      const target = record.target.nodeType === Node.ELEMENT_NODE ? record.target : record.target.parentElement;
      return target?.closest(selector) || [...record.addedNodes].some(node =>
        node.nodeType === Node.ELEMENT_NODE && (node.matches(selector) || node.querySelector(selector)));
    })) schedule();
  });
  const start = () => {
    update();
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
